import { getAddonRows } from '../../helpers/AddonValidity';

// What the pane's Add-ons section has to show, decided once here from the page's own inputs (the product from the
// batch map, the company interval and whether the batch failed) instead of being re-derived from loose props.
//   ready:       the rows are known (possibly none): the section lists them or says "No add-ons."
//   failed:      the batch failed and there is nothing earlier to show: the section says they could not be loaded
//   unavailable: the batch succeeded but rest-api did not send the field (older rest-api): no section
//   loading:     the batch or the company interval has not arrived yet: no section
export const ADDONS_PANEL_STATUS = Object.freeze({
	LOADING: 'loading',
	FAILED: 'failed',
	UNAVAILABLE: 'unavailable',
	READY: 'ready',
});

const NO_ROWS = Object.freeze([]);

// Frozen shared constants: a pane that is not ready always receives the same object, so a re-render cannot
// change its props.
export const ADDONS_PANEL_LOADING = Object.freeze({ status: ADDONS_PANEL_STATUS.LOADING, rows: NO_ROWS });
const ADDONS_PANEL_FAILED = Object.freeze({ status: ADDONS_PANEL_STATUS.FAILED, rows: NO_ROWS });
const ADDONS_PANEL_UNAVAILABLE = Object.freeze({ status: ADDONS_PANEL_STATUS.UNAVAILABLE, rows: NO_ROWS });

// `product` is `{ currentUpgradeChannel, productAddons }` from the batch map, or undefined when the batch has not
// returned it. `productAddons` is null when rest-api omitted the field. Add-ons already known are never replaced by
// the failure line: a later failed batch keeps them.
export const buildAddonsPanel = (product, { interval, loadFailed }) => {
	const rows = getAddonRows(product?.productAddons, interval);

	if (rows) {
		return Object.freeze({ status: ADDONS_PANEL_STATUS.READY, rows });
	}

	if (Array.isArray(product?.productAddons)) {
		return ADDONS_PANEL_LOADING;
	}

	if (loadFailed) {
		return ADDONS_PANEL_FAILED;
	}

	return product ? ADDONS_PANEL_UNAVAILABLE : ADDONS_PANEL_LOADING;
};
